import React from "react";

import { Icon, Header, Image, Responsive } from "semantic-ui-react";
import { withRouter } from "react-router";

class Navbar extends React.Component {
  state = {
    modules: {},
    width: 0,
  };

  handleItemClick = (e, { name }) => {
    this.setState({ activeItem: name });
  };
  handleLogout = () => {
    this.props.logout();
  };
  handleClear = () => {
    this.props.clear(() => this.props.history.push("/"));
  };
  handleChangeScheme = () => {
    this.props.SetScheme();
  };

  render() {
    return (
      <React.Fragment>
        <Responsive {...Responsive.onlyMobile}>
          <div className="headerBar">
            <div style={{ width: "100%" }}>
              <div style={{ justifyContent: "space-between", display: "flex" }}>
                <Image
                  size="small"
                  centered
                  src={require("../assets/paws.png")}
                />
                <Image
                  size="small"
                  centered
                  src={require("../assets/nsk.png")}
                />
              </div>
              <Header as={"h1"} textAlign="center">
                Kent Search and Rescue Dogs
              </Header>
              <Header as={"h2"} textAlign="center">
                Paws In The Park 2024
              </Header>
              <Header as={"h4"} textAlign="center">
                <Icon
                  name="home"
                  size="large"
                  className="clickable"
                  onClick={() => this.props.history.push("/")}
                />
              </Header>
            </div>
          </div>
        </Responsive>
        <Responsive minWidth={768}>
          <div className="headerBar">
            <Image size="small" centered src={require("../assets/paws.png")} />
            <div>
              <Header as={"h1"} textAlign="center">
                Kent Search and Rescue Dogs
              </Header>
              <Header as={"h2"} textAlign="center">
                Paws In The Park 2026
              </Header>
              <Header as={"h4"} textAlign="center">
                <Icon
                  name="home"
                  size="large"
                  className="clickable"
                  onClick={() => this.props.history.push("/")}
                />
              </Header>
            </div>
            <Image size="small" centered src={require("../assets/nsk.png")} />
          </div>
        </Responsive>
      </React.Fragment>
    );
  }
}
const MainNav = withRouter(Navbar);
export default MainNav;
